module.exports = __webpack_public_path__ + "static/media/guide-modal.18db9b05.jpg";